import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, EventEmitter, Input, Output, Renderer2, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AppService, Channel, LINK_TYPES, LinkService, Notification, ThemeType } from '@portals/api';
import { BaseComponent, ResponseService, WindowRef } from '@portals/core';
import { AuthState, ChannelsState, NotificationsState, RolesState, UsersState } from '@portals/store';
import { NgxQrcodeElementTypes, NgxQrcodeErrorCorrectionLevels } from '@techiediaries/ngx-qrcode';
import { ngxLoadingAnimationTypes } from 'ngx-loading';
import { tap } from 'rxjs';
import { customAlphabet } from 'nanoid';
import { CookieService } from 'ngx-cookie';
import { DeviceDetectorService } from 'ngx-device-detector';
import { MatDialog } from '@angular/material/dialog';
import { RESPONSE_TYPES, SCREENS } from '@portals/utils';
import { TranslateService } from '@ngx-translate/core';
import {environment} from "@portals/environments";
@Component({
	selector: 'jotto-app-welcome',
	templateUrl: './welcome.component.html',
	styleUrls: ['./welcome.component.scss'],
})
export class WelcomeComponent extends BaseComponent implements AfterViewInit {
	@ViewChild('appContainer', { static: true }) appContainerRef!: ElementRef;
	@ViewChild('mobileView', { static: true }) mobileViewRef!: ElementRef;
	@ViewChild('channelContent', { static: true }) channelContentRef!: ElementRef;
	@Input() scrollable = false;
	@Output() scrollContent = new EventEmitter();
	@Output() responsePageChange = new EventEmitter<boolean>();

	protected readonly LINK_TYPES = LINK_TYPES;
	channel = this.responseService.currentPage?.parameters?.channel as Channel;
	notification = this.responseService.currentPage?.parameters?.notification as Notification;
	uuid = customAlphabet('1234567890abcdef', 10)();
	elementType = NgxQrcodeElementTypes.URL;
	correctionLevel = NgxQrcodeErrorCorrectionLevels.HIGH;
	formLoading = false;
	loaderConfig = {
		animationType: ngxLoadingAnimationTypes.pulse,
		primaryColour: `var(--portals-theme-primary)`,
		secondaryColour: `var(--portals-theme-accent)`,
	};
	form: FormGroup;
	disabled = true;
	dialogRef: any;
	imageMaxWidth = '720px';
	newFollow = <string>this.cookies.get('follows') ? false : true;
	channelImage = 'assets/images/default.png';
	decryptedParam: any;
	isDesktop: boolean;
	isMobile: boolean;
	isTablet: boolean;
	maxHeight = '';
	imageHeight = '';
	theme?: ThemeType;
	startColor = '#491176';
	endColor = '#491176';
	currentLanguage = 'en';
	customLocalizationSet = false;
	constructor(
		private app: AppService,
		private route: ActivatedRoute,
		private router: Router,
		private channelState: ChannelsState,
		private formBuilder: FormBuilder,
		public roles: RolesState,
		private auth: AuthState,
		private user: UsersState,
		private cookies: CookieService,
		private renderer: Renderer2,
		private translate: TranslateService,
		private deviceService: DeviceDetectorService,
		public window: WindowRef,
		public dialog: MatDialog,
		public linkService: LinkService,
		public responseService: ResponseService,
		public notificationsState: NotificationsState
	) {
		super();
		this.form = this.formBuilder.group({
			first_name: [`web-user`],
			last_name: [this.uuid],
			username: [this.uuid],
			password: [this.uuid],
			confirmed: [true],
			blocked: [false],
			role: [1, Validators.required],
			web: [true],
		});
		const systemDefaultLanguage = navigator.language.split('-')[0];
		const supportedLanguages = ['en', 'es'];
		const defaultLanguage = supportedLanguages.includes(systemDefaultLanguage) ? systemDefaultLanguage : 'en';
		translate.setDefaultLang(defaultLanguage);
		window.nativeWindow.resizeTo(300, 600);
		this.imageMaxWidth = this.deviceService.getDeviceInfo().deviceType == 'Mobile' ? window.nativeWindow.innerWidth + 'px' : '100%';
		this.isDesktop = this.deviceService.isDesktop();
		this.isMobile = this.deviceService.isMobile();
		this.isTablet = this.deviceService.isTablet();

		const windowHeight = this.isMobile ? window.nativeWindow.innerHeight : 600;
		this.maxHeight = `${windowHeight - 304}px`;
		this.imageHeight = `${((this.isMobile ? 75 : 95) / 100) * (windowHeight - 304)}px`;
		this.updateColors();
		if (this.notification?.localization) {
			this.currentLanguage = this.notification.localization;
			this.customLocalizationSet = true;
			translate.setDefaultLang(this.notification.localization);
		}
		if (this.channel?.localization && !this.customLocalizationSet) {
			this.currentLanguage = this.channel.localization;
			this.customLocalizationSet = true;
			translate.setDefaultLang(this.channel.localization);
		}
	}

	ngAfterViewInit() {
		const portrait = window.matchMedia('(orientation: portrait)');
		// this.theme = this.channel.links?.theme;
		// console.log(this.channel.links);
		if (this.notification?.links && this.notification.links.theme) {
			this.theme = this.notification.links.theme;
		} else {
			if (this.channel.links && this.channel.links.theme) {
				this.theme = this.channel.links.theme;
			}
		}
		if (this.isMobile) {
			portrait.matches ? null : this.renderer.setStyle(this.mobileViewRef.nativeElement, 'max-width', '100%');
			this.renderer.setStyle(this.channelContentRef.nativeElement, 'padding', '0px 28px 0px');
			if (this.theme && this.theme.background_color) {
				this.renderer.setStyle(this.appContainerRef.nativeElement, 'background', this.theme.background_color);
			} else {
				this.renderer.setStyle(this.appContainerRef.nativeElement, 'background', 'var(--portals-theme-primary)');
			}
			this.renderer.setStyle(this.appContainerRef.nativeElement, 'height', '100vh');
			this.renderer.setStyle(this.appContainerRef.nativeElement, 'max-height', window.innerHeight + 'px');
			this.renderer.setStyle(this.mobileViewRef.nativeElement, 'padding', '20px 0p');
		}

		if (this.isTablet) {
			this.renderer.setStyle(this.mobileViewRef.nativeElement, 'border-radius', '24px');
			this.renderer.setStyle(this.mobileViewRef.nativeElement, 'min-height', '650px');
			this.renderer.setStyle(this.mobileViewRef.nativeElement, 'max-height', '650px');
			this.renderer.setStyle(this.appContainerRef.nativeElement, 'width', '100%');
			if (this.deviceService.device == 'iPhone' && this.deviceService.browser == 'Chrome') {
				this.renderer.setStyle(this.mobileViewRef.nativeElement, 'padding-bottom', '10px');
			}
		}

		if (this.isDesktop) {
			this.renderer.setStyle(this.mobileViewRef.nativeElement, 'min-width', '370px');
			this.renderer.setStyle(this.mobileViewRef.nativeElement, 'max-width', '370px');
			this.renderer.setStyle(this.mobileViewRef.nativeElement, 'min-height', '650px');
			this.renderer.setStyle(this.mobileViewRef.nativeElement, 'max-height', '650px');
		}
		this.route.queryParams.subscribe((params) => {
			params['id'] ? ((this.decryptedParam = this.notification), (this.channelImage = this.channel?.image?.url)) : (this.channelImage = this.channel?.image?.url);
		});
	}
	updateColors() {
		document.documentElement.style.setProperty('--start-color', this.startColor);
		document.documentElement.style.setProperty('--end-color', this.endColor);
	}
	setKeyframeColor(startColor: string, endColor: string) {
		document.documentElement.style.setProperty('--start-color', startColor);
		document.documentElement.style.setProperty('--end-color', endColor);
	}
	getBackgroundColorClass() {
		if (this.theme && this.theme.background_color) {
			this.setKeyframeColor(this.theme.background_color, this.theme.background_color);
			return { background: this.theme.background_color };
		} else {
			return { background: '#491176' };
		}
	}
	async registerUser() {
		await this.scrollContent.emit();
		// Function to check if we've reached the top
		const checkIfAtTop = setInterval(() => {
			const atTop = window.scrollY == 0;
			if (atTop) {
				clearInterval(checkIfAtTop);
				this.formLoading = true;
				this.subscribe(
					this.app.registerUser(this.form.value, this.channel).pipe(
						tap(() => {
							if (window.location.href.includes('subscribe') || !this.notification) {
								this.responseService.navigateTo(SCREENS.CHANNEL_FEED_SCREEN, {
									channel: this.channel,
								});
							} else {
								this.responseService.navigateTo(SCREENS.RESPONSE_SCREEN, {
									channel: this.channel,
									notification: this.notification,
									notificationType: this.notification.response_type ? this.notification.response_type : RESPONSE_TYPES.VIDEO,
								});
							}

							this.notificationsState.patchState({ data: [] });
							// TODO load this earlier
							// this.notificationsState.loadChannelFeed(this.channel.id).subscribe()
						})
					)
				);
			}
		}, 100); // Check every 100 milliseconds
	}

	moveToGray() {
		const grayPortion = document.getElementById('grayPortion');
		grayPortion?.scrollIntoView({ behavior: 'smooth' });
	}

    protected readonly environment = environment;
}
